import { Menu } from 'antd';
import { useState, useEffect } from 'react';
import { EllipsisOutlined } from '@ant-design/icons';
import { useHistory, useLocation } from 'react-router-dom';
import styles from './HeaderNav.module.less';
import { useSelector } from 'react-redux';
import { userSelector, userTagsSelector } from 'redux/selectors/userSelector';

export default function HeaderNav() {
	const location = useLocation();
	const [current, setCurrent] = useState(location.pathname);
	const history = useHistory();
	const userTags = useSelector(userTagsSelector);

	const handleClick = (e: any) => {
		if (e.key === '/support') {
			// Open support page in a new tab
			window.open('https://omnioneenterprise.zendesk.com/hc/en-us/', '_blank');
		} else {
			setCurrent(e.key);
			history.push(e.key);
		}
	};

	useEffect(() => {
		setCurrent(location.pathname);
	}, [location, current]);

	return (
		<>
			<Menu
				onClick={handleClick}
				className={styles.nav}
				selectedKeys={[current]}
				mode="horizontal"
				overflowedIndicator={<EllipsisOutlined className={styles.menuButton} />}
				style={{ flex: 'auto', justifyContent: 'center', minWidth: 0 }}
			>
				<Menu.Item key="/get-started" className={styles.navitem}>
					Home
				</Menu.Item>
				{/* <Menu.Item key="/documentation" className={styles.navitem}>
					Documentation
				</Menu.Item> */}
				<Menu.Item key="/downloads" className={styles.navitem}>
					Downloads
				</Menu.Item>
				<Menu.Item key="/support" className={`${styles.navitem} ${styles.noHover}`}>
					Support
				</Menu.Item>
				{/* <Menu.Item key="/projects" className={styles.navitem}>
					My Projects
				</Menu.Item> */}
			</Menu>
		</>
	);
}
